import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Col, Modal, Row } from 'react-bootstrap';
import { Form, reduxForm } from 'redux-form';
import { actions } from '../../redux/ProductReducer';
import UploadCropComponent from '../../../../common/components/Upload/UploadCrop';
import { Button } from '../../../../common/components';
import { triggerFileUpload } from '../../../../common/components/Upload/UploadRedux';
import { InfoButton } from '../../../../common/components';
import EditDetailsForm from '../../../../common/components/EditDetailsForm/EditDetailsForm';
import { compose } from 'redux';
const Logo = ({ logo }) => (
  <Row>
    <Col xs={4}>
      <label className="control-label">Brand logo</label>
      &nbsp;
      <InfoButton
        content={
          ' Upload Brand logo, which will be applied to any schemes associated with this Brand imminently (impacting Scheme display and documentation inc. historical documents if regenerated)'
        }
      />
    </Col>
    <Col xs={8}>
      {logo ? <img src={logo} alt={''} /> : <span>no logo uploaded.</span>}
    </Col>
  </Row>
);

const BrandDetailsForm = ({
  insurer,
  updateInsurer,
  triggerFileUpload,
  dispatch,
  change,
  submitting,
  handleSubmit,
  onClose,
  onRefreshInsurerPage,
}) => {
  const [isSavingEnabled, setIsSavingEnabled] = useState(false);
  const [isEditingFinished, setIsEditingFinished] = useState(false);
  const [nextInsurerLogo, setNextInsurerLogo] = useState(null);

  const { isSubmitting, hasInsurerBeenUpdated } = useSelector(
    (state) => state.productManagement,
  );

  useEffect(
    () => {
      if (hasInsurerBeenUpdated && isEditingFinished) {
        onClose();
      }
    },
    [isEditingFinished, hasInsurerBeenUpdated, onClose],
  );

  const handleCancelEditInfo = () => {
    onClose();
  };

  const update = (formValues) => {
    return Promise.resolve(updateInsurer(formValues)).then(() => {
      setIsEditingFinished(true);
      onRefreshInsurerPage();
    });
  };

  const handleUpload = () => {
    triggerFileUpload();
  };

  const handleUploadComplete = (data) => {
    dispatch(change('data.relationships.logo_file.data', data.data));
    dispatch(change('data.attributes.logo', data.data.attributes.url));
    setIsSavingEnabled(true);
    setNextInsurerLogo(data.data.attributes.url);
  };

  const enableSaving = () => {
    setIsSavingEnabled(true);
  };

  const logo = nextInsurerLogo ?? insurer.attributes.logo;

  return (
    <Form onSubmit={handleSubmit(update)}>
      <Modal.Body>
        <div>
          <EditDetailsForm context={'brandDetails'} onInputChange={enableSaving} />
          <Logo logo={logo} />

          <hr />
          <UploadCropComponent
            width={355}
            height={238}
            minScale={30}
            circle={false}
            onComplete={handleUploadComplete}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="default"
          className="pull-left"
          handleClick={handleCancelEditInfo}
        >
          Cancel
        </Button>
        <Button
          link
          type="button"
          bsStyle="primary"
          className="btn-blue"
          label={'View Insurer'}
          to={`/admin/organisations/${insurer.relationships.organisation.data.id}`}
        />
        <Button
          type="button"
          bsStyle="primary"
          className="btn-blue"
          disabled={submitting}
          handleClick={handleUpload}
        >
          {submitting ? (
            <i className="fa fa-cog fa-spin" />
          ) : (
            <i className="fa fa-image" />
          )}{' '}
          upload logo
        </Button>
        <Button
          type="submit"
          bsStyle="primary"
          className="pull-right"
          disabled={!isSavingEnabled}
          isLoading={isSubmitting}
        >
          Save
        </Button>
      </Modal.Footer>
    </Form>
  );
};

export default compose(
  connect(
    (state, props) => ({
      initialValues: {
        data: props.insurer,
      },
    }),
    {
      triggerFileUpload: triggerFileUpload,
      updateInsurer: actions.updateInsurer,
    },
  ),
  reduxForm({
    form: 'InsurerDetailsForm',
  }),
)(BrandDetailsForm);
